/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_appsync_graphqlEndpoint": "https://bmpyi3kvvnb5rebfq2jiwoh7pe.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AWS_IAM",
    "aws_appsync_apiKey": "da2-o5xmggficfdinexy4x7oo7h4si",
    "aws_cognito_identity_pool_id": "eu-west-1:03bf357d-fa2c-4e54-ab08-efdb5cbe1128",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_60llagtKS",
    "aws_user_pools_web_client_id": "5977c7qnrougrh7g0g3to1f677",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "slalclientreporting-20230421130449-hostingbucket-uat",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "https://d21cusr7uf0rl7.cloudfront.net"
};


export default awsmobile;
